// extracted by mini-css-extract-plugin
export default {"container":"AddIngredient_container__sx9Ym"};